import { Box } from '@mui/material';
import { DataGrid, type DataGridProps, type GridValidRowModel } from '@mui/x-data-grid';
import type { SxProps, Theme } from '@mui/material/styles';
import { dataGridSx } from '../theme';

/**
 * The standard table (WAF's WafDataGrid pattern): house style + shared
 * defaults. All DataGrid props are forwarded; a caller's `sx` is merged on top.
 */
export function AppDataGrid<R extends GridValidRowModel>(props: DataGridProps<R>) {
  const { sx, ...rest } = props;
  const mergedSx: SxProps<Theme> = sx ? [dataGridSx, ...(Array.isArray(sx) ? sx : [sx])] : dataGridSx;

  // min-width:0 keeps the grid inside flex parents on narrow screens so it
  // scrolls internally instead of pushing the page sideways.
  return (
    <Box sx={{ width: '100%', minWidth: 0, maxWidth: '100%' }}>
      <DataGrid<R> density="compact" disableRowSelectionOnClick autoHeight {...rest} sx={mergedSx} />
    </Box>
  );
}
